var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 15.1666C4.04732 15.1666 0.833984 11.9533 0.833984 7.99992C0.833984 4.04659 4.04732 0.833252 8.00065 0.833252C11.954 0.833252 15.1673 4.04659 15.1673 7.99992C15.1673 11.9533 11.954 15.1666 8.00065 15.1666ZM8.00065 1.83325C4.60065 1.83325 1.83398 4.59992 1.83398 7.99992C1.83398 11.3999 4.60065 14.1666 8.00065 14.1666C11.4007 14.1666 14.1673 11.3999 14.1673 7.99992C14.1673 4.59992 11.4007 1.83325 8.00065 1.83325Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.334 8.5H6.33398C6.06065 8.5 5.83398 8.27333 5.83398 8C5.83398 7.72667 6.06065 7.5 6.33398 7.5H10.334C10.6073 7.5 10.834 7.72667 10.834 8C10.834 8.27333 10.6073 8.5 10.334 8.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6663 10.5C7.53964 10.5 7.41297 10.4534 7.31297 10.3534L5.31297 8.35338C5.11964 8.16004 5.11964 7.84004 5.31297 7.64671L7.31297 5.64671C7.5063 5.45338 7.8263 5.45338 8.01964 5.64671C8.21297 5.84004 8.21297 6.16004 8.01964 6.35338L6.37297 8.00004L8.01964 9.64671C8.21297 9.84004 8.21297 10.16 8.01964 10.3534C7.91964 10.4534 7.79297 10.5 7.6663 10.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.598d94cc3af54f49524f5320c6ed2e58.svg";
export { ForwardRef as ReactComponent };